import { render, staticRenderFns } from "./CategoryExportsIndex.vue?vue&type=template&id=0577dfc2"
import script from "./CategoryExportsIndex.vue?vue&type=script&lang=js"
export * from "./CategoryExportsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports